/* eslint-disable no-plusplus */
import Compress from 'react-image-file-resizer';

export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;

  return true;
};
export const setCookieForAccountPortal = (name, value) => {
  document.cookie = `${name}=${value || ''}; path=/; domain=.plastk.ca`;
};
export const getCookie = name => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const clearCookie = name => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

  return true;
};

export const capitalize = (str = '') => {
  const arr = str.toLowerCase().split(' ');

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr.join(' ');
  return str2;
};

export const getStatusIconClass = (status = '') => {
  switch (status.trim().toLowerCase()) {
    case 'pending':
      return 'icon-clock';
    case 'processing':
      return 'icon-clock';
    case 'approved':
      return 'icon-check-circle';
    case 'rejected':
      return 'icon-error-circle';
    case 'cancelled':
      return 'icon-times-circle';
    default:
      return 'icon-warning';
  }
};

function changeTimezone(date, ianatz) {
  // suppose the date is 12:00 UTC
  const invdate = new Date(
    date.toLocaleString('en-US', {
      timeZone: ianatz,
    }),
  );

  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  const diff = date.getTime() - invdate.getTime();

  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract
}

export const getDateObject = (e = '') => changeTimezone(new Date(e), 'Canada/Eastern');

export const convertToCurrencyFormat = (amount = '0') =>
  `$ ${Number(amount)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
export const convertToPoitsFormat = (amount = '0') =>
  ` ${Number(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export const shortenString = (str, len = 10) => {
  if (str.length > len) {
    return `${str.substring(0, len)}...`;
  }
  return str;
};

export const convertReadable = (amount = 0) =>
  `${
    Math.abs(amount) > 999
      ? `${Math.sign(amount) * (Math.abs(amount) / 1000).toFixed(1)}K`
      : Math.sign(amount) * Math.abs(amount)
  }`;

export const setAccountPortalCookies = ({ token, status, is_free, redirect, label, fcm_device_id }) => {
  setCookieForAccountPortal('old_fcm_id', fcm_device_id);
  setCookieForAccountPortal('plastk_redirect', redirect);
  setCookieForAccountPortal('account_plastk_token', token);
  setCookieForAccountPortal('account_plastk_label', label);
  setCookieForAccountPortal('plastk_is_free', is_free);
  setCookieForAccountPortal('account_plastk_status', status);
  if (redirect === 'plastk-home') {
    setCookieForAccountPortal('plastk-home', true);
  }
  window.open(process.env.REACT_APP_ACCOUNT_URL, '_blank');
};

export const GeoCoder = new window.google.maps.Geocoder();
// gecode based on type = "address" or "latlng" or "place_id"
export const GeoCode = async value => {
  const { results } = await GeoCoder.geocode(value);
  const { address_components, geometry, place_id, formatted_address, types } = results[0];
  const address = {};
  // eslint-disable-next-line no-shadow
  address_components?.forEach(({ short_name, types }) => {
    if (types.includes('administrative_area_level_1')) {
      address.state = short_name;
    } else if (types.includes('administrative_area_level_2')) {
      address.county = short_name;
    } else if (types.includes('locality')) {
      address.city = short_name;
    } else address[types[0]] = short_name;
  });

  return {
    ...address,
    types,
    place_id,
    latlng: {
      lat: geometry?.location?.lat(),
      lng: geometry?.location?.lng(),
    },
    formatted_address,
  };
};

export const compressImage = file =>
  new Promise(resolve => {
    console.log({ file });
    Compress.imageFileResizer(
      file,
      Infinity,
      Infinity,
      'PNG',
      100,
      0,
      uri => {
        resolve(uri);
      },
      'base64',
    );
  });

export const validateProduct = (product, inValidImageUrl) => {
  let errors = [
    !product.brand && 'Brand Missing',
    !product.product_description && 'product Description Missing',
    !product.category && 'Category Missing',
    !product?.size && 'Size Missing or Unit Missing',
    !product.barcode_number && 'Barcode Number (UPC) Missing',
    !product.product_name && 'Product Name Missing',
    !product.image && 'Image is Missing',
    !product.form && 'Form is Missing',
    inValidImageUrl && 'Image URL is Invalid',
  ].filter(Boolean);

  if (errors.includes('Image is Missing') && errors.includes('Image URL is Invalid')) {
    errors = errors.filter(ex => ex !== 'Image is Missing');
  }

  return { isValid: !errors.length, errors };
};

export const dbCategoryToLongString = category => {
  const cat_name = category?.parent?.map(({ category_name }) => category_name).join(' > ');
  const name = cat_name ? `${cat_name} > ${category?.category_name}` : category?.category_name;
  return name ?? '';
};

export const mergeObjects = (obj1, obj2) => {
  const obj3 = {};
  const keys = Object.keys({ ...obj1, ...obj2 });
  keys.forEach(key => {
    obj3[key] = obj1[key] || obj2[key];
  });
  return obj3;
};

const validateImage = url =>
  new Promise((resolve, reject) => {
    const img = new Image();
    // eslint-disable-next-line no-multi-assign
    img.onerror = img.onabort = async function () {
      reject();
    };
    img.onload = function () {
      resolve();
    };
    img.src = url;
  });

export const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const ProvinceLatLng = {
  Canada: {
    lat: 56.130366,
    lng: -106.346771,
  },
  Alberta: {
    lat: 53.9332706,
    lng: -116.5765035,
  },

  'British Columbia': {
    lat: 53.7266683,
    lng: -127.6476205,
  },

  Manitoba: {
    lat: 53.7608608,
    lng: -98.8138762,
  },

  'New Brunswick': {
    lat: 46.5653163,
    lng: -66.46191639999999,
  },

  'Newfoundland and Labrador': {
    lat: 53.1355091,
    lng: -57.6604364,
  },

  'Northwest Territories': {
    lat: 64.8255441,
    lng: -124.8457334,
  },

  'Nova Scotia': {
    lat: 44.68198659999999,
    lng: -63.744311,
  },

  Nunavut: {
    lat: 70.2997711,
    lng: -83.10757699999999,
  },

  Quebec: {
    lat: 46.8138783,
    lng: -71.2079809,
  },

  Ontario: {
    lat: 51.253775,
    lng: -85.323214,
  },

  'Prince Edward Island': {
    lat: 46.510712,
    lng: -63.41681359999999,
  },

  Saskatchewan: {
    lat: 52.9399159,
    lng: -106.4508639,
  },

  Yukon: {
    lat: 64.2823274,
    lng: -135,
  },
};

const checkValidImageProtocol = url => {
  if (/(http(s?)):\/\//i.test(url)) {
    return true;
  }
  return false;
};

const checkValidImageExtension = url => {
  if (['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG'].includes(url.split(/[#?]/)[0].split('.').pop().trim())) {
    return true;
  }
  return false;
};

export const checkInValidImage = async url => {
  try {
    await validateImage(url);
    return !(checkValidImageExtension(url) && checkValidImageProtocol(url));
  } catch (ex) {
    return true;
  }
};

export const ProvinceLatLngKeys = {
  CA: {
    lat: 56.130366,
    lng: -106.346771,
  },
  AB: {
    lat: 53.9332706,
    lng: -116.5765035,
  },

  BC: {
    lat: 53.7266683,
    lng: -127.6476205,
  },

  MB: {
    lat: 53.7608608,
    lng: -98.8138762,
  },

  NB: {
    lat: 46.5653163,
    lng: -66.46191639999999,
  },

  NL: {
    lat: 53.1355091,
    lng: -57.6604364,
  },

  NS: {
    lat: 64.8255441,
    lng: -124.8457334,
  },

  NT: {
    lat: 44.68198659999999,
    lng: -63.744311,
  },

  NU: {
    lat: 70.2997711,
    lng: -83.10757699999999,
  },

  QC: {
    lat: 46.8138783,
    lng: -71.2079809,
  },

  ON: {
    lat: 51.253775,
    lng: -85.323214,
  },

  PE: {
    lat: 46.510712,
    lng: -63.41681359999999,
  },

  SK: {
    lat: 52.9399159,
    lng: -106.4508639,
  },

  YT: {
    lat: 64.2823274,
    lng: -135,
  },
};
